import { render, staticRenderFns } from "./main-left-bar.vue?vue&type=template&id=555c1b20&scoped=true"
import script from "./main-left-bar.vue?vue&type=script&lang=js"
export * from "./main-left-bar.vue?vue&type=script&lang=js"
import style0 from "./main-left-bar.vue?vue&type=style&index=0&id=555c1b20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555c1b20",
  null
  
)

export default component.exports